export const inputClassName =
  "mt-1 appearance-none relative block w-full px-3 py-2 border border-[#30363D] placeholder-gray-400 text-white bg-[#161B22] rounded-md focus:outline-none focus:ring-[#58A6FF] focus:border-[#58A6FF] focus:z-10 sm:text-sm";
export const labelClassName = "block text-sm font-medium text-white";
export const inputErrorClassName = "mt-1 text-sm text-red-400";
